import React from 'react';
import moment from 'moment';
import { capitalize } from 'lodash';
import withFormValidations from 'react-validator';
import NewPostHoc from './NewPostHoc';
import TransitionMotionModal from 'transitionmotion-modal';
import Modal from 'react-modal';
import { ImageCrop } from 'ui-components';
import GeneralPost from './GeneralPost';
import SpecialPost from './SpecialPost';
import DealPost from './DealPost';
import Limited from './Limited';
import { CONFIG } from 'ui-utilities';

const charLimit = 200;

function validations(type) {
  let fields = [
    {
      label: 'body',
      rules: [
        {
          rule: 'required',
          message: 'Required'
        },
        {
          rule: 'min',
          args: charLimit,
          message: 'Exceeded maximum characters allowed'
        }
      ]
    }
  ];

  return fields;
}

export class NewPost extends React.Component {
  state = {
    limited: false,
    stripe: false
  };

  componentWillMount() {
    let stripe = document.createElement('script');
    stripe.type = 'text/javascript';

    /* eslint-disable */
    stripe.onload = () => {
      if (StripeCheckout) {
        this.setState({
          stripe: StripeCheckout.configure({
            billingAddress: true,
            email: this.props.customer.get('account').get('email'),
            key: CONFIG.STRIPE_KEY,
            image:
              'https://res.cloudinary.com/localvore-today/image/upload/v1493818971/assets/Localvore_icon.png',
            locale: 'auto',
            token: token =>
              this.props._plan
                .upgradePlan(token, this.props.field('plan'))
                .then(res => this.setState({ limited: false }))
          })
        });
      }
    };
    /* eslint-enable */

    stripe.src = 'https://checkout.stripe.com/checkout.js';
    document.body.appendChild(stripe);

    const isLimited = this.limited(this.props.vendor.get('plan'));
    this.setTypeValidations(isLimited, this.props.social.get('new').get('type'));
    this.setState({ limited: isLimited });
  }

  componentWillReceiveProps(nextProps) {
    // reload validtions if we upgraded the plan
    if (nextProps.vendor.get('plan') !== this.props.vendor.get('plan')) {
      this.setTypeValidations(this.limited(nextProps.vendor.get('plan')), nextProps.social.get('new').get('type'));
    }
  }

  componentWillUnmount = () => {
    this.state.stripe.close();
  };

  setTypeValidations = (limited, type) => {
    const { field } = this.props;

    if (!limited) {
      switch (type) {
        case 'deal':
          this.props.addInputs([
            {
              label: 'dealValue',
              value: 5,
              rules: [
                {
                  rule: 'required',
                  message: 'Deal value is required'
                }
              ]
            },
            {
              label: 'restrictions',
              value: ['None'],
              rules: [
                {
                  rule: 'required',
                  message: 'Specify a restriction'
                }
              ]
            },
            {
              label: 'customRestrictions',
              rules: []
            },
            {
              label: 'purchases',
              value: 1,
              rules: [
                {
                  rule: 'maxNum',
                  args: 1,
                  message: 'At least one purchase is required'
                }
              ]
            },
            {
              label: 'dealsSold',
              value: 50,
              rules: [
                {
                  rule: 'maxNum',
                  args: 50,
                  message: 'Must sell a minimum of 50 deals'
                }
              ]
            },
            {
              label: 'start',
              value: moment(),
              rules: [
                {
                  rule: 'required',
                  message: 'A start date is required'
                }
              ]
            },
            {
              label: 'end',
              value: moment().add(2, 'weeks'),
              rules: []
            },
            {
              label: 'promoLength',
              value: 3,
              rules: [
                {
                  rule: 'required',
                  message: 'A promo length is required'
                },
                {
                  rule: 'maxNum',
                  args: 1,
                  message: 'Promo length must be at least 1 month'
                }
              ]
            },
            {
              label: 'donation',
              rules: [
                {
                  rule: 'requiresOther',
                  args: () => field('recipient').validations.val,
                  message: 'Please specify the recipient for the donation'
                }
              ]
            },
            {
              label: 'recipient',
              rules: [{
                rule: 'requiresOther',
                args: () => field('donation').validations.val,
                message: 'Please specify a donation percentage'
              }]
            },
            {
              label: 'codes',
              rules: []
            },
            {
              label: 'terms',
              rules: [
                {
                  rule: 'required',
                  message: 'Please accept the terms'
                }
              ]
            }
          ]);
          break;

        case 'special':
          this.props.addInputs([
            {
              label: 'start',
              rules: [
                {
                  rule: 'required',
                  message: 'A start date is required'
                }
              ]
            },
            {
              label: 'end',
              rules: []
            },
            {
              label: 'days',
              rules: []
            },
            {
              label: 'hours',
              rules: []
            }
          ]);
          break;

        default:
          break;
      }
    } else {
      this.props.addInputs([
        {
          label: 'plan',
          rules: [
            {
              rule: 'required',
              message: 'Please pick a plan'
            }
          ]
        }
      ]);
    }
  }

  limited(plan) {
    const { entities } = this.props;

    const beginningOfWeek = moment().weekday(0);
    const endOfWeek = moment().weekday(7);

    let counter = 0;

    entities.get('posts').map(p => {
      if (moment(p.inserted_at).isBetween(beginningOfWeek, endOfWeek)) counter++;
    });

    if (plan === 'free' && counter >= this.props.social.get('limit')) {
      return true;
    }

    return false;
  }

  upgrade() {
    const { field } = this.props;
    const money = {
      basic: 8500,
      'enhanced-full': 29500
    };

    field('body').validations.val = '';

    this.state.stripe.open({
      name: 'Localvore',
      description: 'Plan Upgrade to ' + field('plan').validations.val,
      amount: money[field('plan').validations.val]
    });
  }

  savePost = callback => {
    return this.props.valid() && this.props.save();
  };

  render() {
    const {
      crop,
      dismiss,
      dismissAndClose,
      imageToState,
      open,
      saving,
      uncroppedImages,
      valid
    } = this.props;

    let post;

    switch (this.props.social.get('new').get('type')) {
      case 'deal':
        post = <DealPost {...this.props} charLimit={charLimit} />;
        break;
      case 'special':
        post = <SpecialPost {...this.props} charLimit={charLimit} />;
        break;
      default:
        post = <GeneralPost {...this.props} charLimit={charLimit} />;
    }

    if (this.state.limited) post = <Limited {...this.props} />;

    return (
      <TransitionMotionModal
        customClass="fullscreen NewPost"
        customClose={true}
        show={this.props.social.get('new').get('type')}
        toggle={() => dismiss(true)}
      >
        <div className="fixed-top">
          <div className="container">
            <div className="row">
              <div className="col-12 text-right p-half-gutter">
                <div
                  onClick={
                    this.state.limited ? dismissAndClose : () => dismiss(true)
                  }
                >
                  <i className="fa fa-2x icon-lv-cancel" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-9 col-lg-7 mx-auto py-5">
                <div className="h3">
                  Create {capitalize(
                    this.props.social.get('new').get('type')
                  )}{' '}
                  Post
                </div>

                {post}

                <ImageCrop
                  {...this.props}
                  crop={crop}
                  stateCallback={imageToState}
                  persistCallback={() => true}
                  persist={true}
                  uncroppedImages={uncroppedImages}
                />

                <Modal
                  isOpen={open}
                  closeTimeoutMS={150}
                  className="modal-dialog"
                  style={{
                    overlay: {
                      zIndex: 9999,
                      backgroundColor: '#300'
                    },
                    content: {
                      backgroundColor: 'transparent',
                      maxWidth: '335px'
                    }
                  }}
                  contentLabel="New Post Dismissal"
                >
                  <div
                    className="modal-content"
                    style={{ backgroundColor: 'transparent', border: '0' }}
                  >
                    <div
                      className="modal-body text-white text-sm-left"
                      style={{ padding: '0' }}
                    >
                      <p>You haven't finished your post!</p>
                      <div className="d-flex flex-wrap flex-column flex-sm-row">
                        <button
                          className="d-inline-block w-auto px-3 py-2 btn-danger mr-sm-3 mb-3"
                          onClick={dismissAndClose}
                        >
                          Leave this page
                        </button>
                        <div>
                          <button
                            className="d-inline-block btn-link py-2 text-white mb-3"
                            onClick={() => dismiss(false)}
                          >
                            Stay on this page
                          </button>
                        </div>
                        <div>
                          <small>
                            <strong>Caution</strong>: If you leave, your post
                            won't be saved.
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
              </div>
            </div>
          </div>
        </div>
        <div className="post-submit-container container">
          <div className="row no-gutters">
            <div className="col-12 col-md-9 col-lg-7 mx-auto">
              {this.state.limited && (
                <div className="row">
                  <div className="col-6">
                    <button
                      className="w-100 btn btn-lg btn-link"
                      onClick={dismissAndClose}
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      className="w-100 btn btn-lg btn-primary"
                      onClick={() => valid() && this.upgrade()}
                    >
                      Upgrade Account
                    </button>
                  </div>
                </div>
              )}
              {!this.state.limited && (
                <button
                  className="w-100 btn btn-lg btn-primary"
                  onClick={this.savePost}
                  disabled={saving}
                >
                  {saving ? (
                    <span>
                      <i
                        className="fa fa-circle-o-notch slow-spin mr-2"
                        aria-hidden="true"
                      />
                      Creating
                    </span>
                  ) : (
                    'Create'
                  )}{' '}
                  Post
                </button>
              )}
            </div>
          </div>
        </div>
      </TransitionMotionModal>
    );
  }
}

export default withFormValidations(NewPostHoc(NewPost), validations());



// WEBPACK FOOTER //
// ./src/components/Social/NewPost.js